import React, { useState, useRef, useEffect } from "react";
import "./TranslateComponent.css";
import TranslateComponent from "./TranslateComponent";

const GoogleTranslateComponent = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const translateRef = useRef(null);
  const position = useRef({ x: 10, y: 120 });
  const isDragging = useRef(false);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isDragging.current) return;
      e.preventDefault(); // Prevent default behavior
      requestAnimationFrame(() => {
        translateRef.current.style.left = `${e.clientX - position.current.x}px`;
        translateRef.current.style.top = `${e.clientY - position.current.y}px`;
      });
    };

    const handleTouchMove = (e) => {
      if (!isDragging.current) return;
      e.preventDefault(); // Prevent default behavior
      const touch = e.touches[0];
      requestAnimationFrame(() => {
        translateRef.current.style.left = `${touch.clientX - position.current.x}px`;
        translateRef.current.style.top = `${touch.clientY - position.current.y}px`;
      });
    };

    const handleMouseUp = () => {
      isDragging.current = false;
    };

    const handleTouchEnd = () => {
      isDragging.current = false;
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
    document.addEventListener("touchmove", handleTouchMove, { passive: false }); // Add passive: false
    document.addEventListener("touchend", handleTouchEnd);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("touchend", handleTouchEnd);
    };
  }, []);

  const handleMouseDown = (e) => {
    isDragging.current = true;
    position.current = {
      x: e.clientX - translateRef.current.offsetLeft,
      y: e.clientY - translateRef.current.offsetTop,
    };
  };

  const handleTouchStart = (e) => {
    const touch = e.touches[0];
    isDragging.current = true;
    position.current = {
      x: touch.clientX - translateRef.current.offsetLeft,
      y: touch.clientY - translateRef.current.offsetTop,
    };
  };

  return (
    <div
      ref={translateRef}
      className={`translate-container border ${isExpanded ? "expanded" : ""}`}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart} // Add touch start event
      style={{
        position: "absolute",
        left: `${position.current.x}px`,
        top: `${position.current.y}px`,
        cursor: "grab",
      }}
    >
      <TranslateComponent />
    </div>
  );
};

export default GoogleTranslateComponent;